<div class="overlay" (click)="onOverlayClick($event)">
  <div class="session-modal" (click)="$event.stopPropagation()">
    <div class="modal-header">
      <h5>Book Session with {{ first_name }} {{ last_name }}</h5>
      <img src="assets/images/close_button.svg" (click)="close()" alt="Close" />
    </div>

    <div class="mentor-box">
      <div class="avatar" aria-hidden="true">
        {{ first_name[0] }}{{ last_name[0] }}
      </div>
      <div class="mentor-info">
        <div class="mentor-name">{{ first_name }} {{ last_name }}</div>
        <div class="mentor-role">{{ designation }} at {{ company }}</div>
      </div>
    </div>

    <div class="modal-body">
      <form [formGroup]="bookSessionForm">
        <!-- Session Type -->
        <div class="form-group">
          <label for="appointmentType"
            >Session Type
            <span class="required" aria-hidden="true">*</span></label
          >
          <div class="custom-select-wrapper" [class.open]="sessionTypeOpen">
            <div
              class="custom-select-trigger"
              id="appointmentType"
              (click)="toggleSessionType()"
              role="combobox"
              aria-haspopup="listbox"
              [attr.aria-expanded]="sessionTypeOpen"
            >
              <span
                [class.placeholder]="
                  !bookSessionForm.get('appointmentType')?.value
                "
              >
                {{
                  bookSessionForm.get("appointmentType")?.value?.type_name ||
                    "Select Session type"
                }}
              </span>
              <svg
                class="chevron"
                [class.rotated]="sessionTypeOpen"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="2.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              >
                <path d="M19.5 8.25l-7.5 7.5-7.5-7.5" />
              </svg>
            </div>
            <div
              class="custom-select-dropdown"
              role="listbox"
              *ngIf="sessionTypeOpen"
            >
              <div
                class="dropdown-item placeholder-item"
                *ngIf="!appointmentTypes.length"
              >
                <span>No options available</span>
              </div>
              <div
                class="dropdown-item"
                *ngFor="let appointment of appointmentTypes"
                (click)="selectSessionType(appointment)"
                role="option"
                [class.selected]="
                  bookSessionForm.get('appointmentType')?.value?.id ===
                  appointment.id
                "
              >
                {{ appointment.type_name }}
              </div>
            </div>
          </div>
        </div>

        <!-- Date -->
        <div class="form-group">
          <label for="date"
            >Date <span class="required" aria-hidden="true">*</span></label
          >
          <div class="input-wrapper">
            <i class="bi bi-calendar" aria-hidden="true"></i>
            <input
              id="date"
              type="text"
              formControlName="date"
              (change)="onDateChange()"
              #dateInput
              placeholder="Select date"
              readonly
              tabindex="-1"
            />
          </div>
        </div>

        <!-- Duration -->
        <div class="form-group">
          <label for="duration"
            >Duration <span class="required" aria-hidden="true">*</span></label
          >
          <div class="custom-select-wrapper" [class.open]="durationOpen">
            <div
              class="custom-select-trigger"
              id="duration"
              (click)="toggleDuration()"
              role="combobox"
              aria-haspopup="listbox"
              [attr.aria-expanded]="durationOpen"
            >
              <span
                [class.placeholder]="!bookSessionForm.get('duration')?.value"
              >
                {{ getSelectedDurationLabel() || "Select Duration" }}
              </span>
              <svg
                class="chevron"
                [class.rotated]="durationOpen"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="2.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              >
                <path d="M19.5 8.25l-7.5 7.5-7.5-7.5" />
              </svg>
            </div>
            <div
              class="custom-select-dropdown"
              role="listbox"
              *ngIf="durationOpen"
            >
              <div
                class="dropdown-item placeholder-item"
                *ngIf="!sessionPriceType.length"
              >
                <span>Select a session type first</span>
              </div>
              <div
                class="dropdown-item"
                *ngFor="let sessionPrice of sessionPriceType"
                (click)="selectDurationOption(sessionPrice, $event)"
                role="option"
                [class.selected]="
                  bookSessionForm.get('duration')?.value ==
                  sessionPrice.duration_minutes
                "
              >
                {{ sessionPrice.display_label }}
              </div>
            </div>
          </div>
        </div>

        <!-- Time -->
        <div class="form-group">
          <label for="time"
            >Time <span class="required" aria-hidden="true">*</span></label
          >
          <div class="custom-select-wrapper" [class.open]="timeOpen">
            <div
              class="custom-select-trigger"
              id="time"
              (click)="toggleTime()"
              role="combobox"
              aria-haspopup="listbox"
              [attr.aria-expanded]="timeOpen"
            >
              <span [class.placeholder]="!bookSessionForm.get('time')?.value">
                {{
                  bookSessionForm.get("time")?.value?.display || "Select Time"
                }}
              </span>
              <svg
                class="chevron"
                [class.rotated]="timeOpen"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="2.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              >
                <path d="M19.5 8.25l-7.5 7.5-7.5-7.5" />
              </svg>
            </div>
            <div class="custom-select-dropdown" role="listbox" *ngIf="timeOpen">
              <div
                class="dropdown-item placeholder-item"
                *ngIf="!availableTimeSlot.length"
              >
                <span>No slots available</span>
              </div>
              <div
                class="dropdown-item"
                *ngFor="let availableTime of availableTimeSlot"
                (click)="selectTime(availableTime)"
                role="option"
                [class.selected]="
                  bookSessionForm.get('time')?.value?.availability_id ==
                  availableTime.availability_id
                "
              >
                {{ availableTime.display }}
              </div>
            </div>
          </div>
        </div>

        <!-- Topics -->
        <div class="form-group">
          <label for="topic"
            >Topics to be Discussed
            <span class="required" aria-hidden="true">*</span></label
          >
          <textarea
            id="topic"
            formControlName="topic"
            placeholder="e.g. Which topic you want to discuss on..."
          ></textarea>
          <small
            class="smaller-text"
            *ngIf="
              bookSessionForm.controls['topic'].touched &&
              bookSessionForm.controls['topic'].errors?.['minlength']
            "
          >
            Topic description must be at least 10 characters.
          </small>
        </div>
      </form>
    </div>

    <div class="modal-actions">
      <button type="button" class="cancel-btn" (click)="close()">Cancel</button>
      <button
        type="button"
        class="review-btn"
        (click)="PostbookSessionForm()"
        [disabled]="bookSessionForm.invalid || isLoading"
        *hasPermission="PermissionForStudents.MENTOR_BOOK"
      >
        <ng-container *ngIf="isLoading; else noLoading">
          <span
            class="spinner-border spinner-border-sm"
            role="status"
            aria-hidden="true"
          ></span>
          <span> Booking...</span></ng-container
        >
        <ng-template #noLoading> <span> Review Booking →</span></ng-template>
      </button>
    </div>
  </div>
</div>
